import { MutationFunction } from '@tanstack/react-query';
import { InternalAxiosRequestConfig } from 'axios';
import Cookies from 'js-cookie';

import { ACCESS_TOKEN_KEY_CADASTRAL_CHANGE } from 'services/auth';
import { newRelicMonitoringService } from 'services/new-relic-monitoring-service';

import api from '../api';

import type { ChangeCadastralResponse, RequestChangeCadastralType } from 'domains/change-cadastral';

export const embbedAuthToken = (request: InternalAxiosRequestConfig) => {
  const authToken = Cookies.get(ACCESS_TOKEN_KEY_CADASTRAL_CHANGE);
  if (!authToken) {
    const error = new Error('Token não encontrado');

    newRelicMonitoringService.addError(error);
    throw error;
  }

  request.headers.Authorization = `Bearer ${authToken}`;
  return request;
};

export const updateChangeCadastral: MutationFunction<
  ChangeCadastralResponse,
  RequestChangeCadastralType
> = async (data: RequestChangeCadastralType) => {
  api.interceptors.request.use(embbedAuthToken);

  const response = await api.put('/reseller/registration', data);
  return response as unknown as ChangeCadastralResponse;
};
